"use client";

import styles from "./RoyalForm.module.scss";
import { FormStatus } from "@/app_components/form/Form";
import { useFormState } from "@/app_components/form/FormStateContext";


interface RoyalTitleSectionProps {
    title?: string;
}


export function RoyalTitleSection({ title }: RoyalTitleSectionProps) {
    return (
        <div className={styles.title_section}>
            {title && (
                <h1>
                    {title}
                </h1>
            )}
        </div>
    );
}


interface RoyalSubmitButtonProps {
    submitText?: string;
}


export function RoyalSubmitButton({ submitText }: RoyalSubmitButtonProps) {
    const formState = useFormState();
    return (
        <>
            <button
                type="submit"
                disabled={!!(formState.isPending || formState.validationError)}
                title={formState.isPending ? "Processing..." : formState.validationError}>

                {submitText ?? "Submit"}
            </button>

            <FormStatus />
        </>
    );
}
